import React from 'react';
import PropTypes from 'prop-types';
import SegmentedControl from './SegmentedControl';

const TRACKS = [
  { value: 'deterministic', label: 'Deterministic', metric: 'RMSE' },
  { value: 'probabilistic', label: 'Probabilistic', metric: 'MWI' },
];

/**
 * Segmented control for switching between forecast tracks.
 *
 * Thin wrapper over SegmentedControl. Displays track name plus metric badge
 * (RMSE / MWI) for each option when showMetric is true.
 *
 * Public API: { selectedTrack, onSelectTrack, showMetric, fullWidth, size }.
 * fullWidth and size pass straight through to SegmentedControl (phone rows
 * use fullWidth size="lg"); both default to SegmentedControl's own defaults.
 */
export default function TrackSegmentedControl({ selectedTrack, onSelectTrack, showMetric = true, fullWidth, size }) {
  const options = TRACKS.map((t) => ({
    value: t.value,
    label: t.label,
    badge: showMetric ? t.metric : undefined,
  }));
  return (
    <SegmentedControl
      options={options}
      value={selectedTrack}
      onChange={onSelectTrack}
      ariaLabel="Forecast track"
      containerClassName="border border-gray-200/70 dark:border-gray-600/70"
      fullWidth={fullWidth}
      size={size}
    />
  );
}

TrackSegmentedControl.propTypes = {
  selectedTrack: PropTypes.oneOf(['deterministic', 'probabilistic']).isRequired,
  onSelectTrack: PropTypes.func.isRequired,
  showMetric: PropTypes.bool,
  fullWidth: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg']),
};
